import * as tokens from '../../../../../tokens/color.dark.generated.js';
export const componentColorDark = {
    color: {
        feedback: {
            progressIndicator: {
                foreground: {
                    text: {
                        default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_DEFAULT_DARK,
                        inverted: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_INVERTED_DARK,
                        range: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_RANGE_DEFAULT_DARK
                        }
                    }
                },
                monochrome: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_MONOCHROME_SURFACE_TRAIN_LINE_DEFAULT_DARK
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_MONOCHROME_SURFACE_TRACK_LINE_DEFAULT_DARK
                        }
                    }
                },
                inverted: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_INVERTED_SURFACE_TRAIN_LINE_DEFAULT_DARK
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_INVERTED_SURFACE_TRACK_LINE_DEFAULT_DARK
                        }
                    }
                },
                colored: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_COLORED_SURFACE_TRAIN_LINE_DEFAULT_DARK
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_COLORED_SURFACE_TRACK_LINE_DEFAULT_DARK
                        }
                    }
                }
            },
            infoBox: {
                foreground: {
                    icon: {
                        success: tokens.CMP_COLOR_FEEDBACK_INFOBOX_FOREGROUND_ICON_SUCCESS_DARK,
                        error: tokens.CMP_COLOR_FEEDBACK_INFOBOX_FOREGROUND_ICON_ERROR_DARK,
                        warning: tokens.CMP_COLOR_FEEDBACK_INFOBOX_FOREGROUND_ICON_WARNING_DARK,
                        default: tokens.CMP_COLOR_FEEDBACK_INFOBOX_FOREGROUND_ICON_DEFAULT_DARK
                    }
                },
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_FEEDBACK_INFOBOX_SURFACE_FILL_DEFAULT_DARK
                    }
                }
            },
            notificationForeground: {
                icon: {
                    default: tokens.CMP_COLOR_FEEDBACK_NOTIFICATION_FOREGROUND_ICON_DEFAULT_DARK
                }
            }
        },
        action: {
            toggleButton: {
                indicator: {
                    default: tokens.CMP_COLOR_ACTION_TOGGLE_BUTTON_INDICATOR_DEFAULT_DARK
                }
            },
            iconButton: {
                primary: {
                    foreground: {
                        text: {
                            default: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_DEFAULT_DARK,
                            hover: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_HOVER_DARK,
                            pressed: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_PRESSED_DARK,
                            disabled: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_DISABLED_DARK
                        }
                    }
                },
                secondary: {
                    foreground: {
                        text: {
                            default: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_DEFAULT_DARK,
                            hover: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_HOVER_DARK,
                            pressed: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_PRESSED_DARK,
                            disabled: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_DISABLED_DARK
                        }
                    }
                },
                tertiary: {
                    foreground: {
                        text: {
                            default: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_DEFAULT_DARK,
                            hover: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_HOVER_DARK,
                            pressed: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_PRESSED_DARK,
                            disabled: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_DISABLED_DARK
                        }
                    }
                }
            }
        },
        navigation: {
            textLink: {
                foreground: {
                    disabled: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DISABLED_DARK,
                    default: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_DARK,
                    interactive: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_INTERACTIVE_DARK
                }
            }
        },
        forms: {
            extendedSelection: {
                surface: {
                    stroke: {
                        error: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_ERROR_DARK,
                        disabled: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_DISABLED_DARK,
                        default: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_DEFAULT_DARK,
                        interactive: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_INTERACTIVE_DARK
                    }
                }
            },
            slider: {
                surface: {
                    handle: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_DEFAULT_DARK,
                        disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_DISABLED_DARK
                    },
                    track: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_TRACK_DEFAULT_DARK
                    },
                    steps: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_STEPS_DEFAULT_DARK
                    },
                    progress: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_DEFAULT_DARK,
                        interactive: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_INTERACTIVE_DARK,
                        disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_DISABLED_DARK,
                        error: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_ERROR_DARK
                    }
                }
            },
            toggle: {
                inactive: {
                    surface: {
                        default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_DEFAULT_DARK,
                        interactive: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_INTERACTIVE_DARK,
                        disabled: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_DISABLED_DARK,
                        handle: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_HANDLE_DEFAULT_DARK
                        }
                    }
                },
                active: {
                    surface: {
                        default: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_DEFAULT_DARK,
                        disabled: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_DISABLED_DARK
                    }
                }
            },
            listItem: {
                surface: {
                    fill: {
                        interactive: tokens.CMP_COLOR_FORMS_LIST_ITEM_SURFACE_FILL_INTERACTIVE_DARK
                    }
                }
            }
        },
        ui: {
            avatar: {
                foreground: {
                    text: {
                        default: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_TEXT_DEFAULT_DARK,
                        secondary: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_TEXT_SECONDARY_DARK
                    },
                    icons: {
                        default: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_ICONS_DEFAULT_DARK,
                        hover: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_ICONS_HOVER_DARK,
                        pressed: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_ICONS_PRESSED_DARK,
                        disabled: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_ICONS_DISABLED_DARK
                    }
                },
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_AVATAR_SURFACE_FILL_DEFAULT_DARK,
                        disabled: tokens.CMP_COLOR_UI_AVATAR_SURFACE_FILL_DISABLED_DARK,
                        pressed: tokens.CMP_COLOR_UI_AVATAR_SURFACE_FILL_PRESSED_DARK,
                        hover: tokens.CMP_COLOR_UI_AVATAR_SURFACE_FILL_HOVER_DARK
                    }
                }
            },
            accordion: {
                surface: {
                    pressed: tokens.CMP_COLOR_UI_ACCORDION_SURFACE_PRESSED_DARK
                }
            },
            tag: {
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_TAG_SURFACE_FILL_DEFAULT_DARK
                    }
                },
                selected: {
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DEFAULT_DARK,
                            hover: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DISABLED_DARK
                        }
                    }
                },
                unselected: {
                    surface: {
                        stroke: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DEFAULT_DARK,
                            hover: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DISABLED_DARK
                        },
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DEFAULT_DARK,
                            hover: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_INTERACTIVE_DARK,
                            disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DISABLED_DARK
                        }
                    }
                }
            },
            skeleton: {
                surface: {
                    fill: tokens.CMP_COLOR_UI_SKELETON_SURFACE_FILL_DARK
                }
            },
            value: {
                foreground: {
                    label: tokens.CMP_COLOR_UI_VALUE_FOREGROUND_TEXT_LABEL_DARK,
                    caption: tokens.CMP_COLOR_UI_VALUE_FOREGROUND_TEXT_CAPTION_DARK
                }
            },
            table: {
                foreground: {
                    text: {
                        title: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_TITLE_DEFAULT_DARK
                        },
                        headline: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_HEADLINE_DEFAULT_DARK
                        },
                        copy: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_COPY_DEFAULT_DARK
                        }
                    },
                    divider: {
                        default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_DIVIDER_DEFAULT_DARK
                    }
                },
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_TABLE_SURFACE_FILL_DEFAULT_DARK
                    }
                }
            }
        }
    }
};
//# sourceMappingURL=color.dark.js.map